import {
  concatMap,
  filter,
  finalize,
  map,
  share,
  shareReplay,
  switchMap,
  takeUntil,
  tap,
  last,
  catchError,
} from 'rxjs/operators';
import {
  HideLoaderAction,
  ShowLoaderAction,
} from '../loader/load.actioins';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  append,
  patch,
  removeItem,
  updateItem,
} from '@ngxs/store/operators';
import {
  Action,
  ActionCompletion,
  Actions,
  createPickSelector,
  createPropertySelectors,
  createSelector,
  ofActionCompleted,
  ofActionSuccessful,
  Selector,
  State,
  StateContext,
  Store,
} from '@ngxs/store';
import {
  createDeepPropSelector,
  getDeepPatch,
} from '@shared/utils/state.util';
import * as _ from 'lodash';
import { forEach } from 'lodash';
import { AlertService } from 'src/app/core/services/alert.service';
import { MemoService } from 'src/app/modules/memos/service/memo.service';
import {
  AddLoaLevel,
  ChangeLoa,
  ClearMemoPasswordPopup,
  CloseMemoPasswordPopup,
  ContractUploadMultiPDF,
  ContractUploadPDF,
  CreateMemo,
  DdocSettingsUpdateMemo,
  DropdownGetApiUpdateDept,
  DropdownGetApiUpdateMemo,
  UploadEFormFile,
  ErrorNotification,
  MemoCarbonAccountingUpdateMemo,
  MemoCustomLoaAddLoaLevel,
  MemoCustomLoaChangeLoa,
  MemoCustomLoaSetLoa,
  MemoUploadAttachmentUpdateMemo,
  PrepareEFormValidation,
  PreviewMemo,
  RemoveLoaLevel,
  ResetLoa,
  ResetState,
  SaveItemMemo,
  SaveMemo,
  SavePristineMemo,
  SetInitMemo,
  SetLoa,
  SetWidgets,
  ShowMemoPasswordPopup,
  UpdateLoaLevel,
  UpdateMemo,
  UpdateMemoDetail,
  UpdateWidget,
  UploadAttachment,
  UploadEmissionEvidenceFile,
  UploadMemoAddLoaLevel,
  UploadMemoSetCustomLoaLevels,
  UploadMemoSetLoa,
  UploadMemoUploadMultiPDF,
  UploadMemoUploadPDF,
  WidgetPdfHandlerUpdateMemo,
  MemoCustomLoaCalculateDynamicLoa,
  SelectBudgetItem,
  AddBudgetLineItem,
  RemoveBudgetLineItem,
  UpdateBudgetLineItem,
  ManualUpdateBudgetTotal,
  MemoCustomLoaPatchRemoveLower,
} from './memo.actions';
import {
  Memo,
  MemoCreationData,
  MemoPasswordPopUp,
} from './memo.model';
import {
  MemoDetail,
  UploadMemoPatch,
} from 'src/app/modules/memos/model/memo.model';
import {
  EMPTY,
  from,
  lastValueFrom,
  Observable,
  of,
  Subject,
} from 'rxjs';
import { featureFlag } from '../../../environments/environment';
import {
  DDocSigningStatus,
  LoaDetail,
  Signer,
} from '../../modules/loa/shared/loa.model';
import { LoaService } from '../../modules/loa/shared/loa.service';
import { Params } from '@angular/router';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { LoaChangeEvent } from 'src/app/modules/memos/components/upload-memos/loa-customizer/loa-customizer.component';
import { EForm } from 'src/app/modules/e-form/shared/eform.model';
import {
  Marker,
  Widget,
} from 'src/app/modules/memos/components/upload-memos/pdf-signature-customizer/pdf-signature-customizer.model';
import {
  BudgetLoaQueryState,
  MemoBudgetReqState,
} from '@shared/models/budget-request.model';
import { BudgetRequestService } from 'src/app/modules/memos/components/memo-creation/budget/budget-request.service';
import { calculateBudgetControl } from '@shared/utils/budget-request.util';

export type MemoStateModel = Partial<
  MemoDetail & {
    signature_position: Marker[];
    canSetDynamicLOAOption: boolean;

    // is true when memo create/edit template page
    isMemoTemplate: boolean;
  }
>;

@State<MemoStateModel>({
  name: 'memoCreationData',
  defaults: {},
})
@Injectable({
  providedIn: 'root',
})
export class MemoCreationState implements OnDestroy {
  isInitCompleted$: Observable<ActionCompletion>;
  loaChangeObs: Observable<LoaChangeEvent>;

  private action$ = inject(Actions);
  private destroy$ = new Subject<void>();
  private loaChange$ = new Subject<LoaChangeEvent>();
  private loaService = inject(LoaService);
  private budgetReqService = inject(BudgetRequestService);

  // TODO: Refactor to method
  getUploadFileApi = (createMemoRes: any, memoType: string) => {
    const uploadFileApi: any[] = [
      new UploadAttachment(createMemoRes.id),
    ];
    if (
      featureFlag.carbon_accounting_enable &&
      memoType === 'purchase_request'
    ) {
      const purchaseId = createMemoRes.purchase_request?.id;
      uploadFileApi.push(new UploadEmissionEvidenceFile(purchaseId));
    }
    if (memoType === 'upload') {
      const uploadId = createMemoRes.upload.id;
      uploadFileApi.push(new UploadMemoUploadMultiPDF(uploadId));
      uploadFileApi.push(
        new UploadMemoUploadPDF(uploadId, createMemoRes.id),
      );
    }
    if (memoType === 'contract') {
      const contractId = createMemoRes.contract.id;
      uploadFileApi.push(new ContractUploadMultiPDF(contractId));
      uploadFileApi.push(
        new ContractUploadPDF(contractId, createMemoRes.id),
      );
    }
    if (memoType === 'eform') {
      uploadFileApi.push(new UploadEFormFile(createMemoRes.id));
    }
    return uploadFileApi;
  };

  // eslint-disable-next-line @typescript-eslint/member-ordering
  constructor(
    private memoService: MemoService,
    private alert: AlertService,
    private translate: TranslateService,
    private store: Store,
    private spinner: SpinnerService,
  ) {
    this.loaChangeObs = this.loaChange$.asObservable();
    this.isInitCompleted$ = this.action$.pipe(
      ofActionCompleted(SetInitMemo),
      takeUntil(this.destroy$),
      shareReplay({ refCount: true, bufferSize: 1 }),
    );
    this.isInitCompleted$.subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  @Selector()
  static memoCreationData(state: MemoStateModel): MemoStateModel {
    return state;
  }

  @Action([UploadMemoAddLoaLevel, MemoCustomLoaAddLoaLevel])
  addLoaLevel(
    ctx: StateContext<Memo>,
    action: AddLoaLevel,
  ): Observable<void> | any {
    const state = ctx.getState();
    const pushLevelFn = (
      underState: Partial<Memo> | any,
    ): Partial<MemoDetail> => {
      const presentLevel = underState.loa_detail.levels;
      const defaultApprover: Partial<Signer> = {
        is_delegate: false,
        person: null,
        person_detail: null,

        // contract
        evidence: {
          otp_required: false,
          phone_number: null,
          selfie_video_required: false,
          selfie_video_script: null,
          has_request_attachments: false,
          request_attachments: [],
        },
      };
      const newLevel = {
        level: presentLevel.length + 1,
        name: action.name,
        members: [defaultApprover],
        signature_required: true,
        min_approve_count: 1,
        count: 1,
        user_type: 'user',
      };
      if (featureFlag.ddoc) {
        /** Default ddoc_enable of the new level follow last level before */
        const loaLevels = presentLevel;
        const lastLevelDdocEnable =
          loaLevels[(loaLevels.length || 1) - 1]?.ddoc_enable;
        Object.assign(newLevel, {
          ddoc_enable: lastLevelDdocEnable || false,
        });
        /** fill default signing status */
        const defaultSigningStatus: DDocSigningStatus = {
          ddoc_use_26: lastLevelDdocEnable || false,
          ddoc_use_28: false,
          ddoc_certified_mode: false,
          ddoc_locked_mode: false,
        };
        Object.assign(defaultApprover, defaultSigningStatus);
      }
      if ('ddoc_enable' in newLevel && newLevel.ddoc_enable) {
        // contract
        if (newLevel.members[0]?.evidence) {
          newLevel.members[0].evidence.otp_required = true;
        }
      }
      const loaDetailPatch = {
        ...underState.loa_detail,
        levels: [...(underState.loa_detail.levels || []), newLevel],
        is_custom: true,
      };
      return { loa_detail: loaDetailPatch };
    };
    if (state.loa_detail == null) {
      return ctx.dispatch(new ResetLoa()).pipe(
        tap(() => {
          ctx.patchState(pushLevelFn(ctx.getState()));
        }),
      );
    }
    ctx.patchState(pushLevelFn(state));
  }

  getDepartmentChangeAction(): Observable<DropdownGetApiUpdateDept> {
    let department: MemoDetail['department'];
    return this.action$.pipe(
      ofActionSuccessful(DropdownGetApiUpdateDept),
      filter((action) => {
        const isDepartmentChanged = !_.isEqualWith(
          department,
          action.value,
          (obj1, obj2) => (obj1 == null && obj2 == null) || undefined,
        );
        return isDepartmentChanged;
      }),
      tap((action) => {
        department = action.value;
      }),
      share(),
    );
  }

  getSaveItemMemoAction(): Observable<SaveItemMemo> {
    return this.action$.pipe(ofActionSuccessful(SaveItemMemo));
  }

  /**  Create & Update Memo */
  @Action([SaveMemo, SetInitMemo])
  save(
    { setState }: StateContext<MemoCreationData<MemoDetail>>,
    { payload }: any,
  ): void {
    // re-run EForm-related objects' constructors after save or update
    if (!(payload.eform instanceof EForm)) {
      payload.eform = new EForm(payload.eform);
    }

    setState({
      ...payload,
    });
  }

  @Action([
    SaveItemMemo,
    MemoCarbonAccountingUpdateMemo,
    SavePristineMemo,
  ])
  saveItem(
    ctx: StateContext<Partial<MemoDetail>>,
    { value, name }: { value: any; name: string },
  ): void {
    const statePatch: Params = {
      [name]: value,
    };
    ctx.setState(patch(statePatch));
  }

  @Action([
    DdocSettingsUpdateMemo,
    DropdownGetApiUpdateDept,
    DropdownGetApiUpdateMemo,
    MemoUploadAttachmentUpdateMemo,
    WidgetPdfHandlerUpdateMemo,
  ])
  updateItem(
    ctx: StateContext<Partial<MemoDetail>>,
    action: UpdateMemoDetail,
  ): void {
    const state = getDeepPatch(action.key, action.value);
    ctx.setState(state);
  }

  @Action(RemoveLoaLevel)
  removeLoaLevel(
    ctx: StateContext<Memo>,
    action: RemoveLoaLevel,
  ): void {
    const state: any = ctx.getState();
    const loa = state.loa_detail;
    if (state.loa_detail.levels?.length < 1) {
      return;
    }
    const index = action.index ?? loa.levels.length - 1;
    const loaRemoved = loa.levels.splice(index, 1);
    // It does not patch with immutable because it change only level inside loa_detail.
    // To update loa_detail state without trigger loa_detail state change but
    // trigger by loaChange$ instead.
    ctx.patchState({
      loa_detail: loa,
    });
    this.loaChange$.next({
      levelIndex: index,
      result: loaRemoved,
      snapshot: loaRemoved,
      actionType: 'removeLevel',
      level: index + 1,
    });
  }

  @Action(ResetLoa)
  resetLoa(ctx: StateContext<Memo>): void {
    ctx.patchState({
      loa_detail: { levels: [] },
    });
    this.loaChange$.next({} as LoaChangeEvent);
  }

  @Action(ResetState)
  resetState({ setState }: StateContext<Partial<MemoDetail>>): void {
    setState({});
    this.loaChange$.next({} as LoaChangeEvent);
  }

  @Action(CreateMemo)
  createMemo(
    { getState }: StateContext<MemoCreationData<any>>,
    { payload }: { payload: any },
  ): Observable<MemoDetail> {
    this.store.dispatch(new ShowLoaderAction());
    return this.memoService.createMemo(payload).pipe(
      // ดูว่าทำไม่ถึงใช้ switchMap ที่ action 'UpdateMemo'
      // look at notes in action 'UpdateMemo' on why I use switchMap.
      switchMap((createMemoRes) => {
        const uploadFileApi = this.getUploadFileApi(
          createMemoRes,
          payload.memo_type,
        );
        return this.store
          .dispatch(uploadFileApi)
          .pipe(map(() => createMemoRes));
      }),
      tap((res) => {
        // re-attach attachment since updateMemo api don't send attachment back
        res.attachments = payload.attachments;
        this.store.dispatch(new SaveMemo(res));
      }),
      finalize(() => {
        this.store.dispatch(new HideLoaderAction());
        this.spinner.hide();
      }),
    );
  }

  @Action(PreviewMemo)
  previewMemo(
    { getState }: StateContext<MemoCreationData<any>>,
    { payload }: { payload: any },
  ): Observable<MemoDetail> {
    this.store.dispatch(new ShowLoaderAction());
    return this.memoService.createMemo(payload).pipe(
      // ดูว่าทำไม่ถึงใช้ switchMap ที่ action 'UpdateMemo'
      // look at notes in action 'UpdateMemo' on why I use switchMap.
      switchMap((createMemoRes) => {
        const uploadFileApi = this.getUploadFileApi(
          createMemoRes,
          payload.memo_type,
        );
        return this.store
          .dispatch(uploadFileApi)
          .pipe(map(() => createMemoRes));
      }),
      tap((res) => {
        this.store.dispatch(
          new SaveItemMemo(res.signed_document, 'signed_document'),
        );
        this.store.dispatch(new SaveItemMemo(res.id, 'id'));
      }),
      finalize(() => {
        this.store.dispatch(new HideLoaderAction());
      }),
    );
  }

  @Action([UploadMemoSetLoa, MemoCustomLoaSetLoa])
  updateLoa(ctx: StateContext<MemoStateModel>, action: SetLoa): void {
    let loaPatch: Partial<MemoDetail> = {};
    const loa = action.loaGroup;
    if (loa == null) {
      loaPatch = { loa_detail: null, loa_group: null };
    } else {
      loaPatch = loa?.is_custom
        ? { loa_detail: loa, loa_group: null }
        : { loa_detail: _.cloneDeep(loa), loa_group: loa };
    }
    ctx.patchState(loaPatch);
    this.loaChange$.next({} as LoaChangeEvent);
  }

  @Action(MemoCustomLoaPatchRemoveLower)
  patchIsRemoveLower(
    ctx: StateContext<MemoStateModel>,
    action: MemoCustomLoaPatchRemoveLower,
  ) {
    const loa_detail = ctx.getState()?.loa_detail;
    if (!loa_detail) {
      return;
    }
    ctx.patchState({
      loa_detail: {
        ...loa_detail,
        is_remove_lower: action.value,
      },
    });
  }

  @Action(UploadMemoSetCustomLoaLevels)
  setLoaLevels(
    ctx: StateContext<MemoStateModel>,
    action: UploadMemoSetCustomLoaLevels,
  ): void {
    const loaDetailState = ctx.getState().loa_detail;
    ctx.patchState({
      loa_detail: loaDetailState && {
        ...loaDetailState,
        levels: [...action.loaLevels],
      },
    });
    this.loaChange$.next({} as LoaChangeEvent);
  }

  @Action(UpdateLoaLevel)
  updateLoaLevel(
    ctx: StateContext<Memo>,
    action: UpdateLoaLevel,
  ): void {
    ctx.setState(
      getDeepPatch(
        ['loa_detail', 'levels', action.index.toString()],
        action.updatedLoaLevel,
      ),
    );
    if (action.event) {
      this.loaChange$.next(action.event);
    }
  }

  @Action([MemoCustomLoaChangeLoa], {
    cancelUncompleted: true,
  })
  changeLoa(ctx: StateContext<MemoStateModel>, action: ChangeLoa) {
    if (!action.loaId) {
      this.updateLoa(ctx, { loaGroup: null });
      return;
    }
    return this.loaService
      .getLOAData(action.loaId, {
        include_custom: true,
        ...(action.params || {}),
      })
      .pipe(
        switchMap((res: unknown) => {
          const loa = res as LoaDetail;
          const state = ctx.getState();
          const isMemoTemplate = state?.isMemoTemplate;
          if (
            !isMemoTemplate &&
            loa?.has_dynamic_loa &&
            !loa?.init_dynamic_loa
          ) {
            const departmentId = ctx.getState().department;

            return this.loaService
              .initDynamicLOAMembers(action.loaId, departmentId)
              .pipe(
                catchError((err) => {
                  if (err?.error?.code === 'LOA_HAS_NO_LEVEL') {
                    this.alert.error(
                      this.translate.instant(
                        'DYNAMIC-LOA.ERROR-SELECT-LOA-NO-LEVEL',
                      ),
                    );
                    return of(null);
                  } else {
                    throw err;
                  }
                }),
              );
          } else {
            return of(res);
          }
        }),
        tap({
          next: (data) => {
            this.updateLoa(ctx, { loaGroup: data as LoaDetail });
          },
        }),
      );
  }

  @Action([MemoCustomLoaCalculateDynamicLoa], {
    cancelUncompleted: true,
  })
  async calculateDynamicLoa(
    ctx: StateContext<MemoStateModel>,
    action: MemoCustomLoaCalculateDynamicLoa,
  ) {
    const state = ctx.getState();
    // must clone signature_position to snapshot current state
    const currentSigPos =
      _.cloneDeep(state?.upload?.signature_position) || null;

    let dynamicLoa: LoaDetail;
    try {
      const res = await lastValueFrom(
        this.loaService.initDynamicLOAMembers(
          action.loaId,
          action.departmentId,
        ),
      );
      dynamicLoa = res as LoaDetail;
    } catch (err: any) {
      if (err?.error?.code === 'LOA_HAS_NO_LEVEL') {
        this.alert.error(
          this.translate.instant(
            'DYNAMIC-LOA.ERROR-TEMPLATE-LOA-NO-LEVEL',
          ),
        );
      } else {
        this.alert.error('Init Dynamic LOA failed');
      }
      return;
    }
    this.updateLoa(ctx, { loaGroup: dynamicLoa as LoaDetail });

    if (!action.initSigPos) {
      return;
    }
    if (state.memo_type !== 'upload' || !state.memo_template) {
      return;
    }

    try {
      const newSigPos = await lastValueFrom(
        this.loaService.initDynamicLOASignaturePosition(
          state.memo_template,
          action.loaId,
          dynamicLoa,
          currentSigPos,
        ),
      );

      await lastValueFrom(
        this.store.dispatch(new SetWidgets(newSigPos as Widget[])),
      );
    } catch (error) {
      this.alert.error('Init signature position failed');
      return;
    }
  }

  @Action(UpdateMemo)
  updateMemo(
    { getState }: StateContext<MemoCreationData<MemoDetail>>,
    { id, payload }: { id: number; payload: any },
  ): Observable<MemoDetail> {
    this.store.dispatch(new ShowLoaderAction());
    return this.memoService.updateMemo(id, payload).pipe(
      // TH: Note 1: ที่เราทำ switchMap ตรงนี้เพราะว่า ต้องการดูว่า action 'UploadFile' มันสำเร็จหรือเปล่า
      //       ถ้ามันไม่สำเร็จ ก็คนที่ subscribe function นี้ก็จะได้ event error กลับไปด้วย
      //     Note 2: ที่มีการ 'pipe(map(() => updateMemoRes))' ตอนท้ายก็เพราะต้องการให้ tap ด้านล่างมัน process
      //       response ของ updateMemo ไม่ใช่ response ของ UploadFile
      //
      // EN: Note 1: I use switchMap here because I want to wait for 'UploadFile' action finished.
      //       if it is failed, the error event to raised to everyone that subscribe to this function.
      //     Note 2: I use 'pipe(map(() => updateMemoRes))' in the end because I want 'tap' below to process
      //       response of 'updateMemo', not response of 'UploadFile'
      switchMap((updateMemoRes) => {
        const uploadFileApi = this.getUploadFileApi(
          updateMemoRes,
          payload.memo_type,
        );
        return from(uploadFileApi).pipe(
          concatMap((action) => this.store.dispatch(action)),
          last(), // emit only the final result
          map(() => updateMemoRes),
        );
      }),
      tap((res) => {
        this.store.dispatch(
          new SaveItemMemo(res.signed_document, 'signed_document'),
        );
        this.store.dispatch(new SaveItemMemo(res.id, 'id'));
      }),
      finalize(() => {
        this.store.dispatch(new HideLoaderAction());
        this.spinner.hide();
      }),
    );
  }

  @Action(UploadAttachment)
  uploadAttachment(
    { getState }: StateContext<MemoStateModel>,
    { id }: { id: number },
  ): Observable<any> {
    const payload = getState() as MemoDetail;
    if (!payload.attachments || payload.attachments.length === 0) {
      return EMPTY;
    }
    const fd = new FormData();
    fd.append('memo', id.toString());
    forEach(payload.attachments, (attachFile: any, index) => {
      const i = index + 1;
      if (attachFile.id) {
        fd.append(i.toString(), attachFile.id.toString());
      } else {
        const file = attachFile.file;
        file.fileEntry
          ? fd.append(i.toString(), file.fileEntry)
          : fd.append(i.toString(), file);
      }
    });
    return this.memoService.uploadMemoAttachment(fd).pipe(
      tap({
        next: (res: [] | any) => {
          const attachments = payload.attachments.filter(
            (file: any) => file.id,
          );
          if (res.length) {
            attachments.push(...res);
          }
          this.store.dispatch(
            new SaveItemMemo(attachments, 'attachments'),
          );
        },
      }),
    );
  }

  @Action(UploadEmissionEvidenceFile)
  uploadEmissionEvidenceFile(
    { getState }: StateContext<MemoCreationData<any>>,
    { purchaseId }: { purchaseId: number },
  ): Observable<any> {
    const file = getState().new_emission_evidence_file;
    if (!file) {
      return EMPTY;
    }
    const fd = new FormData();
    const fileToAppend = file.fileEntry || file;
    fd.append(
      'evidence_file',
      fileToAppend,
      file.name || 'relativePath',
    );
    return this.memoService
      .uploadEmissionEvidenceFile(purchaseId, fd)
      .pipe(
        tap({
          next: () => {
            this.store.dispatch(
              new MemoCarbonAccountingUpdateMemo(
                null,
                'new_emission_evidence_file',
              ),
            );
          },
        }),
      );
  }

  @Action(UploadMemoUploadPDF)
  uploadMemoUploadPDF(
    { getState }: StateContext<any>,
    { uploadId, memoId }: { uploadId: number; memoId: number },
  ): Observable<unknown> {
    const currentPdfFile = (getState().upload as UploadMemoPatch)
      .uploaded_pdf;
    const previousPdfFile = (getState().pristineMemo as MemoDetail)
      ?.upload?.uploaded_pdf;
    const uploadFormData = new FormData();
    if (currentPdfFile == null && previousPdfFile) {
      return this.memoService.removeBlob({
        memo: memoId,
      });
    }
    const isFinalPdfFileChange = (getState().upload as any)
      .onUploadFileChange;
    if (isFinalPdfFileChange) {
      uploadFormData.append('uploaded_pdf', currentPdfFile);
      uploadFormData.append(
        'uploaded_pdf_name',
        (currentPdfFile as any).name,
      );
      return this.memoService.uploadBlob(uploadId, uploadFormData);
    }
    return EMPTY;
  }

  @Action(UploadMemoUploadMultiPDF)
  uploadMemoUploadMultiPDF(
    { getState }: StateContext<any>,
    { uploadId }: { uploadId: number },
  ): Observable<any> {
    const uploadPdfFiles = (getState().upload as UploadMemoPatch)
      .multiUploadPdfUpdate;
    const multiUploadPdfDetail = (
      getState().upload as UploadMemoPatch
    ).multi_upload_pdf_detail;
    const uploadMultiFormData = new FormData();
    if (uploadPdfFiles) {
      uploadPdfFiles.multi_upload_pdf_files.forEach((file) => {
        uploadMultiFormData.append('multi_upload_pdf_files', file);
      });
      uploadMultiFormData.append(
        'multi_upload_pdf_details',
        JSON.stringify(uploadPdfFiles.multi_upload_pdf_details),
      );
    }
    const pristineMemo = getState().pristineMemo as MemoDetail;
    const isChanged =
      !!uploadPdfFiles ||
      pristineMemo?.upload?.multi_upload_pdf_detail
        ?.upload_file_details.length !==
        multiUploadPdfDetail?.upload_file_details?.length;
    return !isChanged
      ? EMPTY
      : this.memoService.uploadMultiBlob(
          uploadId,
          uploadMultiFormData,
        );
  }

  @Action(ContractUploadPDF)
  contractUploadPDF(
    { getState }: StateContext<any>,
    { contractId, memoId }: { contractId: number; memoId: number },
  ): Observable<unknown> {
    const currentPdfFile = (getState().contract as UploadMemoPatch)
      .uploaded_pdf;
    const previousPdfFile = (getState().pristineMemo as MemoDetail)
      ?.upload?.uploaded_pdf;
    const fd = new FormData();
    if (currentPdfFile == null && previousPdfFile) {
      return this.memoService.removeContractBlob({
        memo: memoId,
      });
    }
    const isFinalPdfFileChange =
      currentPdfFile && typeof currentPdfFile === 'object';
    if (isFinalPdfFileChange) {
      fd.append('uploaded_pdf', currentPdfFile);
      return this.memoService.uploadContractBlob(contractId, fd);
    }
    return EMPTY;
  }

  @Action(ContractUploadMultiPDF)
  contractUploadMultiPDF(
    { getState }: StateContext<any>,
    { contractId }: { contractId: number },
  ): Observable<any> {
    const uploadPdfFiles = (getState().contract as UploadMemoPatch)
      .multiUploadPdfUpdate;
    const multiUploadPdfDetail = (
      getState().contract as UploadMemoPatch
    ).multi_upload_pdf_detail;
    const fd = new FormData();
    if (uploadPdfFiles) {
      uploadPdfFiles.multi_upload_pdf_files.forEach((file) => {
        fd.append('multi_upload_pdf_files', file);
      });
      fd.append(
        'multi_upload_pdf_details',
        JSON.stringify(uploadPdfFiles.multi_upload_pdf_details),
      );
    }
    const pristineMemo = getState().pristineMemo as MemoDetail;
    const isChanged =
      !!uploadPdfFiles ||
      pristineMemo?.contract?.multi_upload_pdf_detail
        ?.upload_file_details.length !==
        multiUploadPdfDetail?.upload_file_details?.length;
    return !isChanged
      ? EMPTY
      : this.memoService.uploadContractMultiBlob(contractId, fd);
  }

  @Action(UploadEFormFile)
  uploadEFormFile(
    { getState }: StateContext<any>,
    { memoId }: { memoId: number },
  ) {
    const eForm = getState().eform as EForm;
    const filesToUpload = eForm.getAllFileData(true);

    if (!filesToUpload.length) return EMPTY;

    const filesToUploadFD = new FormData();
    filesToUploadFD.set('memo', memoId.toString());

    for (const fileData of filesToUpload) {
      if (!fileData || !fileData.file) continue;
      filesToUploadFD.set(
        `${fileData.type}[${fileData.file_key}]`,
        fileData.file,
      );
    }

    return this.memoService.uploadEFormFiles(filesToUploadFD);
  }

  /**  Check Error Message */
  @Action(ErrorNotification)
  errorNotification(
    { getState }: StateContext<MemoCreationData<any>>,
    { error }: any,
  ): void {
    if (
      error?.error?.message ===
        'cannot sign document. please enable OTP in profile page.' ||
      error?.error?.message ===
        'ไม่สามารถลงลายเซ็นได้ กรุณาเปิด OTP ที่หน้าผู้ใช้งานก่อน'
    ) {
      this.alert.otpSettingWarning();
      return;
    }
    if (error.error && error.error.en) {
      this.alert.error(
        error.error[this.translate.currentLang].join('\n'),
      );
    } else if (error.error && error.error.non_field_errors) {
      const non_field_errors: string[] = error.error.non_field_errors;
      this.alert.error(non_field_errors.join('\n'));
    } else if (
      error.error &&
      typeof error.error === 'string' &&
      error.error.length > 2000
    ) {
      // don't show message if it is too long to prevent chrome freeze.
      this.alert.error();
    } else if (error.error) {
      const errorInfos: string[] = [];
      for (const value of Object.values(error.error || {})) {
        if (typeof value === 'string') {
          errorInfos.push(value);
        } else if (Array.isArray(value)) {
          const biLangError = value
            .filter((i) =>
              Object.keys(i).includes(this.translate.currentLang),
            )
            .map((error) => error[this.translate.currentLang]);
          if (biLangError.length) {
            errorInfos.push(...biLangError);
          }
          errorInfos.push(
            ...value.filter((i) => typeof i === 'string'),
          );
        }
      }
      if (errorInfos.length > 200) {
        // don't show message if it is too long to prevent chrome freeze.
        this.alert.error();
      } else {
        this.alert.error(errorInfos.join('\n'));
      }
    } else {
      this.alert.error();
    }
  }

  @Action(SetWidgets)
  setWidget(ctx: StateContext<MemoStateModel>, action: SetWidgets) {
    const { memo_type } = ctx.getState();
    if (!memo_type) {
      return;
    }
    ctx.setState(
      patch({
        [memo_type]: patch({
          signature_position: [...action.widget],
        }),
      }),
    );
  }

  @Action(UpdateWidget)
  updateWidget(
    ctx: StateContext<MemoStateModel>,
    action: UpdateWidget,
  ) {
    const state = ctx.getState();
    if (!state.upload && !state.contract) {
      throw new Error('Invalid action, upload or contract not found');
    }
    if (state.upload) {
      state.upload.signature_position[action.index] = action.widget;
      ctx.setState(
        patch({
          upload: state.upload,
        }),
      );
    }
    if (state.contract) {
      state.contract.signature_position[action.index] = action.widget;
      ctx.setState(
        patch({
          contract: state.contract,
        }),
      );
    }
  }

  @Action(PrepareEFormValidation)
  prepareEFormValidation({
    patchState,
    getState,
  }: StateContext<MemoStateModel>) {
    const state = getState();
    const eform = state.eform;

    if (eform) {
      eform.validate();
      patchState({
        eform: eform,
      });
    }
  }

  @Action(SelectBudgetItem)
  selectBudgetItem(
    { patchState }: StateContext<Params>,
    action: SelectBudgetItem,
  ) {
    patchState({
      budget_item: action.budgetItemId,
      budget_item_detail: action.detail,
    });
  }

  @Action(AddBudgetLineItem)
  addBudgetLineItem(
    { getState, setState }: StateContext<Params>,
    action: AddBudgetLineItem,
  ) {
    setState(
      patch({
        line_items: append([action.item]),
      }),
    );
    const line_items = getState()['line_items'];
    const result = this.budgetReqService.calculateAll(line_items);
    setState(patch(result));
  }

  @Action(RemoveBudgetLineItem)
  removeBudgetLineItem(
    { getState, setState }: StateContext<Params>,
    action: RemoveBudgetLineItem,
  ) {
    setState(
      patch({
        line_items: removeItem(action.index),
      }),
    );
    const line_items = getState()['line_items'];
    const result = this.budgetReqService.calculateAll(line_items);
    setState(patch(result));
  }

  @Action(UpdateBudgetLineItem)
  updateBudgetLineItem(
    { getState, setState }: StateContext<Params>,
    { index, key, value }: UpdateBudgetLineItem,
  ) {
    const line_items = getState()['line_items'];
    const target = line_items[index];
    target[key] = value;
    this.budgetReqService.calculateLineItem(target);
    const result = this.budgetReqService.calculateAll(line_items);
    setState(
      patch({
        line_items: updateItem(index, target),
        ...result,
      }),
    );
  }

  @Action(ManualUpdateBudgetTotal)
  manualUpdateBudgetTotal(
    { getState, setState }: StateContext<MemoBudgetReqState>,
    { key, value }: ManualUpdateBudgetTotal,
  ) {
    setState(
      patch({
        [key]: value,
      }),
    );
    const state = getState();
    const { total_net_amount } =
      this.budgetReqService.calculateTotalForManualUpdate(
        state.sub_total,
        {
          total_vat_amount: state.total_vat_amount,
          total_wht_0_75_amount: state.total_wht_0_75_amount,
          total_wht_1_amount: state.total_wht_1_amount,
          total_wht_1_5_amount: state.total_wht_1_5_amount,
          total_wht_2_amount: state.total_wht_2_amount,
          total_wht_3_amount: state.total_wht_3_amount,
          total_wht_5_amount: state.total_wht_5_amount,
          total_wht_10_amount: state.total_wht_10_amount,
          total_wht_15_amount: state.total_wht_15_amount,
        },
      );
    setState(
      patch({
        total_net_amount,
      }),
    );
  }
}

export class MemoDetailSelectors {
  static fullDetail = createSelector(
    [MemoCreationState],
    (state) => state as MemoDetail,
  );

  static slices =
    createPropertySelectors<MemoDetail>(MemoCreationState);

  static deepSlice = createDeepPropSelector(MemoCreationState);

  static budgetReq = createSelector([MemoCreationState], (state) => {
    return {
      budget: state?.budget,
      budget_department: state?.budget_department,
      budget_item: state?.budget_item,
      budget_item_detail: state?.budget_item_detail,
      line_items: state?.line_items,

      sub_total: state?.sub_total,
      total_vat_amount: state?.total_vat_amount,
      total_wht_0_75_amount: state?.total_wht_0_75_amount,
      total_wht_1_amount: state?.total_wht_1_amount,
      total_wht_1_5_amount: state?.total_wht_1_5_amount,
      total_wht_2_amount: state?.total_wht_2_amount,
      total_wht_3_amount: state?.total_wht_3_amount,
      total_wht_5_amount: state?.total_wht_5_amount,
      total_wht_10_amount: state?.total_wht_10_amount,
      total_wht_15_amount: state?.total_wht_15_amount,
      total_net_amount: state?.total_net_amount,
    } as Partial<MemoBudgetReqState>;
  });

  static budgetLoaQuery = createSelector(
    [this.budgetReq],
    (state) => {
      const budgetControl = calculateBudgetControl(state);
      return {
        department: state?.budget_item_detail?.department?.id || null,
        category: state?.budget_item_detail?.category?.id || null,
        amount: state?.sub_total || null,
        is_over_budget: budgetControl.remaining_actual < 0,
      } as BudgetLoaQueryState;
    },
  );

  static uploadState(controlName = 'upload') {
    return createSelector(
      [MemoCreationState],
      (state) => state[controlName] as UploadMemoPatch,
    );
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  static widgets(uploadControlName = 'upload') {
    return createPickSelector(this.uploadState(uploadControlName), [
      'signature_position',
    ]);
  }
}

@State<MemoPasswordPopUp>({
  name: 'memoPasswordPopUp',
  defaults: {
    show: false,
    password: null,
    isCreator: false,
    memoId: null,
  },
})
@Injectable({
  providedIn: 'root',
})
export class MemoPasswordPopupState {
  @Action(ShowMemoPasswordPopup)
  showMemoPasswordPopup(
    { patchState }: StateContext<MemoPasswordPopUp>,
    {
      isCreator,
      memoId,
    }: { isCreator: boolean; memoId: number | null },
  ) {
    patchState({
      show: true,
      isCreator: isCreator,
      memoId: memoId,
    });
  }

  @Action(CloseMemoPasswordPopup)
  closeMemoPasswordPopup(
    { patchState }: StateContext<MemoPasswordPopUp>,
    { password }: { password: string | null },
  ) {
    patchState({
      show: false,
      password: password,
      isCreator: false,
      memoId: null,
    });
  }

  @Action(ClearMemoPasswordPopup)
  clearMemoPasswordPopup({
    setState,
  }: StateContext<MemoPasswordPopUp>) {
    setState({
      show: false,
      password: null,
      isCreator: false,
      memoId: null,
    });
  }
}
